import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { makeStyles, Tooltip } from '@material-ui/core';
import { QueuePlayNext } from '@material-ui/icons';
import { Link, LinkProps } from '@reach/router';
import React from 'react';
import { generatePath } from 'react-router-dom';

import { FontSizes } from '../../../../core/config/mainTheme';
import { ROUTES } from '../../../../routes';

export interface BenchmarkLinkState {
  switchToRefinementTab: boolean;
}

export type BenchmarkLocationProps = {
  location: LinkProps<BenchmarkLinkState>;
};

interface OwnProps extends ICellRendererParams {
  toolTipText?: string;
}

const BenchmarkLinkCellRenderer: React.FC<OwnProps> = ({ data, toolTipText }) => {
  const classes = useStyles();
  const path = generatePath(ROUTES.benchmarking.benchmark, { benchmarkId: data.id });
  const linkState: BenchmarkLinkState = {
    switchToRefinementTab: !!data?.refinementSearchId,
  };

  return (
    <Link to={path} className={classes.link} state={linkState}>
      <Tooltip title={toolTipText || ''} arrow>
        <QueuePlayNext />
      </Tooltip>
    </Link>
  );
};

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: FontSizes.fontWeight.bold,
    cursor: 'pointer',
    marginLeft: -1 * (theme.spacing(6) + 1),
    marginRight: -1 * (theme.spacing(6) + 1),
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(4),
  },
}));

export default BenchmarkLinkCellRenderer;
